import { useMemo } from 'react'
import {
  BooleanModifier,
  FormModelModifiers,
  NumberModifier,
  SelectOptionModifier,
  TextModifier,
} from '../../../containers/SingleSheetV2/model/formModelModifiers'
import { ValidateSingleSheetPropertyValue } from '../../../containers/SingleSheetV2/hooks/formValidation'
import { OnChangeTenant } from './useTenantFormState'

// 表示専用の alias は編集できないため modifier を持たない。
export const useTenantModelModifier = (
  onChangeTenant: OnChangeTenant,
  validate: ValidateSingleSheetPropertyValue
): FormModelModifiers => {
  return useMemo<FormModelModifiers>(() => {
    const text =
      (
        field:
          | 'iconUrl'
          | 'displayName'
          | 'officialName'
          | 'emailDomainWhitelist'
      ): TextModifier =>
      v => {
        onChangeTenant(field, v ?? '')
        validate(field, v)
      }
    const checkbox =
      (
        field: 'skipEmailVerification' | 'restrictTaskActualWorkByProjectPeriod'
      ): BooleanModifier =>
      v => {
        onChangeTenant(field, v ?? false)
        validate(field, v)
      }
    const select =
      (
        field: 'defaultTimezoneId' | 'financialYearEndMonth'
      ): SelectOptionModifier =>
      v => {
        onChangeTenant(field, v)
        validate(field, v)
      }
    const number =
      (field: 'dailyWorkHours' | 'monthlyWorkDays'): NumberModifier =>
      v => {
        onChangeTenant(field, v)
        validate(field, v)
      }

    return {
      iconUrl: text('iconUrl'),
      displayName: text('displayName'),
      officialName: text('officialName'),
      emailDomainWhitelist: text('emailDomainWhitelist'),
      skipEmailVerification: checkbox('skipEmailVerification'),
      defaultTimezoneId: select('defaultTimezoneId'),
      dailyWorkHours: number('dailyWorkHours'),
      monthlyWorkDays: number('monthlyWorkDays'),
      financialYearEndMonth: select('financialYearEndMonth'),
      restrictTaskActualWorkByProjectPeriod: checkbox(
        'restrictTaskActualWorkByProjectPeriod'
      ),
    }
  }, [onChangeTenant, validate])
}
